import { render, staticRenderFns } from "./UndoPpaRejectionAction.vue?vue&type=template&id=6218035b&scoped=true"
import script from "./UndoPpaRejectionAction.vue?vue&type=script&lang=js"
export * from "./UndoPpaRejectionAction.vue?vue&type=script&lang=js"
import "./UndoPpaRejectionAction.vue?vue&type=style&index=0&id=6218035b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6218035b",
  null
  
)

export default component.exports